import NiceModal from '@ebay/nice-modal-react';

import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/field/Button';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import ConnectSalesChannelModal from 'pages/SalesChannels/ConnectSalesChannelModal';
import { getOnlineStoreBySlug } from 'pages/SalesChannels/salesChannelDetailsSlice';

import PATHS, { mergePaths } from 'utils/paths';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import APIIntegrations from './APIIntegrations';
import ConnectedTokens from './ConnectedTokens';

const OtoAPI = () => {
	const dispatch = useDispatch();
	const { loading } = useSelector((state) => state.salesChannel);

	const tabs = useMemo(
		() => [
			{
				label: 'apiIntegrations',
				path: mergePaths(PATHS.API_INTEGRATIONS, PATHS.OTO_API),
				component: APIIntegrations
			},
			{
				label: 'connectedTokens',
				path: mergePaths(PATHS.API_INTEGRATIONS, PATHS.CONNECTED_TOKENS),
				component: ConnectedTokens
			}
		],
		[]
	);

	useEffect(() => {
		dispatch(getOnlineStoreBySlug('oto-api'));
	}, []);

	if (loading) return <Loading />;
	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/oto-api.json.gz"
				title="apiIntegrations">
				<Button icon={faPlus} label="connectStore" onClick={() => NiceModal.show(ConnectSalesChannelModal)} />
			</PageHeader>
			<Tabs data={tabs} checkURL />
		</div>
	);
};

export default OtoAPI;
